import { pack, unpack } from './JsonRPC';

export default { JsonRPC: { pack, unpack } };